import { render, staticRenderFns } from "./my-uploadTwo.vue?vue&type=template&id=21fe7316&scoped=true"
import script from "./my-uploadTwo.vue?vue&type=script&lang=js"
export * from "./my-uploadTwo.vue?vue&type=script&lang=js"
import style0 from "./my-uploadTwo.vue?vue&type=style&index=0&id=21fe7316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe7316",
  null
  
)

export default component.exports